export const HairData = [
  {
    index: 1,
    heading: "Balayage",
    content:
      "Hand-painted, seamless colour designed to grow out beautifully. Perfect for soft, sun-kissed dimension or lived-in lightening.",
  },
  {
    index: 2,
    heading: "Colour Correction",
    content:
      "For when your colour needs rescuing or rebalancing gently and professionally, with scalp and strand integrity in mind.",
  },
  {
    index: 3,
    heading: "Grey Coverage / Full Tint",
    content:
      "A custom-blended tint to cover greys or enhance your natural colour. Includes bond-builder treatment for hair strength and shine.",
  },
  {
    index: 4,
    heading: "Colour Matching (Wigs & Extensions)",
    content:
      "Expert colour blending for wigs, toppers, or extensions to ensure seamless harmony with your natural hair. All colour services include a treatment, with bond-building options available to protect and restore the hair during and after colouring.",
  },
  {
    index: 5,
    heading: "Curly Cut",
    content:
      "A bespoke dry or wet cut designed specifically for curly, wavy, or coily hair. Enhances natural shape, definition, and movement.",
  },
  {
    index: 6,
    heading: "Highlights",
    content:
      "Classic foils or modern techniques tailored to your look from subtle brightness to bold contrast. Includes toner + aftercare treatment.",
  },
  {
    index: 7,
    heading: "Precision Cut & Blow-Dry",
    content:
      "Tailored to your texture, lifestyle, and personal style with education on how to maintain the look at home.",
  },
  {
    index: 8,
    heading: "Event Styling",
    content:
      "Red carpet, editorial, or special occasions from sleek to statement.",
  },
];
